import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveClient, fetchClientProjectDropdown, fetchClientProjectDropdownClear, fetchClientProjectService, changeProjectStatus, fetchProject, createProjectRequest, fetchEmployeeDropdownAutoList, getProserviceList, getOrgProjectCount } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import useButtonAccess from "components/Common/useButtonAccess";
import { PROJECT_STATUS_OPTIONS } from "common/data/constants";
import { FaCheckCircle, FaTimesCircle, FaHourglass, FaPauseCircle, FaSpinner } from "react-icons/fa";

const TimeSheetProject = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const { 
      project, 
      proserviceList,
      clientActiveList,
      clientProjectService,
      clientProjectDropdown,
      dropdownAutoList,
      orgProjectCount,
      loading,
      success,
      error, 
  } = useSelector((state) => ({
      project : state.TimesheetSetupProjectReducer?.project  ?? [],
      clientActiveList : state.TimesheetSetupClientReducer?.clientActiveList  ?? [],
      clientProjectService : state.TimesheetSetupProjectReducer?.clientProjectService  ?? [],
      clientProjectDropdown : state.TimesheetSetupProjectReducer?.clientProjectDropdown  ?? [], 
      dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
      proserviceList : state.TimesheetSetupProjectReducer?.proserviceList  ?? [],
      orgProjectCount : state.TimesheetSetupProjectReducer?.orgProjectCount  ?? null,

      loading: state.TimesheetSetupProjectReducer?.loading,
      error: state.TimesheetSetupProjectReducer?.error,
      success: state.TimesheetSetupProjectReducer?.success,
  }));

  const project_list = project?.list_proj ?? [];

    
  useEffect(() => {
      resetFormData();
      const authUserDetails = useAuthUserDetails();
      setAuthDetails(authUserDetails[0])
      const unitId = authUserDetails[0].unit_id     
      const create_by= authUserDetails[0].user_id;    
      dispatch(fetchActiveClient(unitId));      
      dispatch(fetchProject(unitId,create_by));     
      dispatch(fetchEmployeeDropdownAutoList(unitId));  
      const formData = new FormData();
      formData.append("unit_id", unitId);

      dispatch(getOrgProjectCount(formData));
  }, [dispatch]); 

  useEffect(() => {
      if(success){
          dispatch(fetchProject(authDetails?.unit_id,authDetails?.user_id));  
          const formData = new FormData();
          formData.append("unit_id", authDetails?.unit_id);
          dispatch(getOrgProjectCount(formData));
          resetFormData();
      }
  }, [authDetails,success,dispatch]);
  
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [clientData,setClientData] = useState(null);
  const [serviceData,setServiceData] = useState(null);
  const [assignToData,setAssignToData] = useState(null);
  const [assignToIds,setAssignToIds] = useState([]);

  const [tableData, setTableData] = useState([]);

//   const projectServiceList = React.useMemo(() => ([
//   {
//     service_name: "test",
//     service_id: "1",
//     project_code: "PRJ001",
//     project: "New developement testing ",
//     project_id: 1681,
//     client_id: 1,
//     project_totalhours: 260,
//     assign_id: 0,
//     assign_name: "",
//     assign_hours: 0
//   },
//   {
//     service_name: "UX Services",
//     service_id: "5",
//     project_code: "PRJ001",
//     project: "New developement testing ",
//     project_id: 1681,
//     client_id: 1,
//     project_totalhours: 260,
//     assign_id: 0,
//     assign_name: "",
//     assign_hours: 0
//   },
//   {
//     service_name: "Wordpress Maintenance",
//     service_id: "8",
//     project_code: "PRJ001",
//     project: "New developement testing ",
//     project_id: 1681,
//     client_id: 1,
//     project_totalhours: 260,
//     assign_id: 0,
//     assign_name: "",
//     assign_hours: 0
//   }
// ]), []);


  useEffect(() => {
    const accessRight = getAccessRights(location.pathname,history);
  }, [location]);

  useEffect(() => {
    if (clientProjectDropdown?.project_code) {
      formik.setFieldValue("projectCode", clientProjectDropdown.project_code);
    }
  }, [clientProjectDropdown?.project_code]);

  useEffect(() => {
    if (clientProjectDropdown?.assignTo && isEdit && assignToIds.length>0) {      
      const selectedValues = clientProjectDropdown?.assignTo.filter(option => assignToIds.includes(String(option.value)));
      formik.setFieldValue("assignTo", selectedValues); 
      setAssignToData(selectedValues); 
    }
  }, [clientProjectDropdown?.assignTo && isEdit && assignToIds.length>0]);


  const formatTimeWithColon = (val) => {
    const str = String(val ?? "");   // ✅ force string

    const digits = str.replace(/\D/g, "").slice(0, 5);

    if (digits.length <= 2) return digits;
    if (digits.length === 3) return digits;

    const hoursLength = digits.length === 4 ? 2 : 3;
    return `${digits.slice(0, hoursLength)}:${digits.slice(hoursLength)}`;
  };

  const formatOnBlur = (input) => {
    if (!input) return "";

    // split if colon exists
    if (input.includes(":")) {
      let [h, m = ""] = input.split(":");

      h = h.replace(/\D/g, "").slice(0, 4);
      m = m.replace(/\D/g, "").slice(0, 2);

      if (!h) h = "0";
      if (m.length === 0) m = "00";

      m = Math.min(Number(m), 59).toString().padStart(2, "0");

      return `${h}:${m}`;
    }

    // no colon → digits only
    const digits = input.replace(/\D/g, "").slice(0, 6);

    if (digits.length <= 4) {
      return `${digits}:00`;          // 10 → 10:00
    }

    const hours = digits.slice(0, digits.length - 2);
    const minutes = Math.min(
      Number(digits.slice(-2)),
      59
    ).toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const formatWhileTyping = (value) => {
    return value
      .replace(/[^0-9:]/g, "")     // allow digits + colon
      .replace(/:(?=.*:)/g, "")   // only ONE colon
      .slice(0, 7);               // max 9999:59
  };

  const normalizeHours = (input) => {
    const str = String(input ?? "");   // ✅ force string

    if (!str) return "";

    const digits = str.replace(/\D/g, "").slice(0, 5);

    if (digits.length === 1) return `0${digits}:00`;
    if (digits.length === 2) return `${digits}:00`;
    if (digits.length === 3) return `${digits}:00`;

    if (digits.length === 4) {
      const hours = digits.slice(0, 2);
      const minutes = Math.min(+digits.slice(2), 59)
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    const hours = digits.slice(0, 3);
    const minutes = Math.min(+digits.slice(3), 59)
      .toString()
      .padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    if (Array.isArray(proserviceList) && proserviceList.length) {
      const rows = proserviceList.map(item => ({
        id: item.service_id,
        service: item.service_name,
        project_code: item.project_code,
        project_name: item.project_name || "",
        project_name_details: item.project_name_details || "",
        project_status: item.project_status || "",
        assigned_to: item.assign_id ? String(item.assign_id) : "",
        total_hours: item.assign_hours
          ? normalizeHours(item.assign_hours)
          : ""
      }));

      formik.setFieldValue("rows", rows, false);
    } else {
      formik.setFieldValue("rows", [], false);
    }
  }, [proserviceList]);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      client: "",
      service: [],
      projectCode: "",
      projectName: "",
      projectStatus: "",
      description: "",
      hours: "",
      assignTo: "",
      accountOwner: "",
      rows: [],
      projectvalue: "",
    },
    validationSchema: Yup.object({
      client: Yup.string().nullable().required("Client is required"),
      // service: Yup.object().required("Service is required"),
      // service: Yup.array()
      // .min(1, "At least one service is required")
      // .required("Service is required"),
      // projectCode: Yup.string().required("Project Code is required"),
      projectName: Yup.string().required("Project Name is required"),
      //hours: Yup.number().required("Hours is required"),
      hours: Yup.string()
            .trim()
            .required("Task Hours is required")
            .matches(
              /^(?:\d{1,4}):[0-5]\d$/,
              "Enter valid time (max 9999:59)"
            ),
      // assignTo: Yup.array().min(1, "Project Owner is required"),
      // assignTo: Yup.string().nullable().required("Project Owner is required"),
      accountOwner: Yup.string().nullable()
        .required("Account Owner is required"),
      // projectStatus: Yup.object().required("Project Status is required"),
      rows: Yup.array().of(
        Yup.object({
          project_name: Yup.string().trim().required("Name is required"),
          project_status: Yup.string().trim().required("Status is required"),
          assigned_to: Yup.string()
            .trim()
            .required("Assigned To is required"),

          total_hours: Yup.string()
            .trim()
            .required("Task Hours is required")
            .matches(
              /^(?:\d{1,4}):[0-5]\d$/,
              "Enter valid time (max 9999:59)"
            )
        })
      )
    }),
    onSubmit: (values, { resetForm }) => {
      const lst_timesheet_ProjectServiceType = {
        ser_timesheet: values.rows.map((row, index) => {
          // ✅ parse orgProjectCount safely
          const baseCount =
            orgProjectCount && !isNaN(Number(orgProjectCount))
              ? Number(orgProjectCount)
              : 0;

          const seq = editId
            ? row.project_code // edit mode → keep original
            : `${row.project_code} ${baseCount + index + 1}`; // create mode → concat count + row index

          return {
            project_dtl_id: row.project_dtl_id ? row.project_dtl_id : 0,
            service_id: row.id,
            project_name: row.project_name,
            project_status: row.project_status,
            account_owner_id: row.assigned_to,
            project_code: seq,
            task_hours: row.total_hours,
          };
        }),
      };

      const formData = new FormData();

      formData.append("project_id", editId ? editId : 0);
      // formData.append("project_code", values.projectCode);
      formData.append("project_name", values.projectName);

      // service ids (if service[] dropdown exists)
      const serviceIds = values.service?.map(s => s.value).join(",");
      // formData.append("service_id", serviceIds || "");

      formData.append("client_id", values.client);
      formData.append("description", values.description);
      formData.append("hours", values.hours);

      // 🔑 Project Owner (single)
      formData.append("assign_id", values.assignTo || 0);
      formData.append("account_manager", values.accountOwner);
      formData.append("project_value", values.projectvalue);

      // 🔑 Created user
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);

      // 🔑 Status
      // formData.append("status", values.projectStatus.value || 0);

      // 🔥 NEW FIELD (IMPORTANT)
      formData.append(
        "lst_timesheet_ProjectServiceType",
        JSON.stringify(lst_timesheet_ProjectServiceType)
      );

      dispatch(createProjectRequest(formData));
    },
  });

  useEffect(() => {
    if (!formik.values.client) {
      formik.setFieldValue("rows", []);
    }
  }, [formik.values.client]);


   const [editServiceIds, setEditServiceIds] = useState([]);
  // const handleEdit = (row) => {

  //   setIsEdit(true);
  //   setEditId(row.project_id);

  //   generateProjectCode(row.service_id,row.client_id);
  //   fetchServiceData(row.client_id);
   
  //   const selectedIds = row.project_owner_id ? row.project_owner_id.split(",") : [];
  //   const trimmedSelectedIds = selectedIds.map(str => str.trim());
   
  //   //setTimeout(function(){      
  //     const selectedValues = clientProjectDropdown?.assignTo ? clientProjectDropdown?.assignTo.filter(option => trimmedSelectedIds.includes(String(option.value))) : [];
  //     formik.setValues({
  //       project_id: row.project_id,
  //       projectCode: row.project_code,
  //       projectName: row.project_name,
  //       description: row.project_description,
  //       hours: row.project_hours,
  //       assignTo: selectedValues,
  //       projectStatus: row.status_name,
  //     });      

  //     const serviceIds = row.ServiceId ? row.ServiceId.split(",").map(id => id.trim()) : [];
  //     setEditServiceIds(serviceIds);
  //     setClientData({value:row.client_id,label:row.client_name});    
  //     //setServiceData({value:row.service_id,label:row.service_name});  
  //     setAssignToData(selectedValues); 
      
  //     formik.setFieldValue("client", {value:row.client_id,label:row.client_name});
  //     formik.setFieldValue("service", {value:row.service_id,label:row.service_name});
  //     formik.setFieldValue("assignTo", selectedValues);
  //     formik.setFieldValue("projectStatus", { value: row.status, label: row.status_name });
  //     setAssignToIds(trimmedSelectedIds);
      
  //   //},1000);    
          
  // };


  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.project_id);

    // Map Project Owner
    const projectOwnerOption = userOptions.find(
      opt => opt.value === String(row.project_owner_id)
    ) || null;

    // Map Account Owner
    const accountOwnerOption = userOptions.find(
      opt => opt.value === String(row.account_manager_id)
    ) || null;

    // Map Client
    const clientOption = clientActiveList.find(
      opt => String(opt.value) === String(row.client_id)
    ) || null;

   const projectStatusOption = PROJECT_STATUS_OPTIONS.find(
      opt => String(opt.value) === String(row.status)
    ) || null;

    const getProjectStatusOption = (status) =>
    PROJECT_STATUS_OPTIONS.find(
      opt => String(opt.value) === String(status)
    ) || "";

    // Map services rows
    const rows = project?.list_service
      ?.filter(s => s.project_id === row.project_id)
      .map(service => ({
        project_dtl_id: service.project_det_id,
        id: service.service_id,
        service: service.service_name,
        project_code: service.project_code,
        project_name: service.project_name,
        project_status: getProjectStatusOption(
        service.project_status)?.value || "",
        assigned_to: String(service.account_owner),
        total_hours: service.service_hours || ""
      })) || [];

    // Set Formik values
    formik.setValues({
      client: clientOption?.value || "",
      // service: row.service_id || "",
      projectCode: row.project_code || "",
      projectName: row.project_name || "",
      projectStatus: projectStatusOption,
      description: row.project_description || "",
      hours: row.project_hours || "",
      assignTo: projectOwnerOption?.value || "",
      accountOwner: accountOwnerOption?.value || "",
      projectvalue: row.project_value || "",
      rows
    });
  };
 
  const [editassignidIds, seteditassignidIds] = useState([]);
  useEffect(() => {
    if (editServiceIds.length > 0 && Array.isArray(clientProjectService) && clientProjectService.length > 0) {
      const selectedServices = clientProjectService.filter(opt =>        editServiceIds.includes(String(opt.value))     );
      formik.setFieldValue("service", selectedServices);
      setServiceData(selectedServices);
    }
  }, [clientProjectService, editServiceIds,editassignidIds]);

  const userOptions = React.useMemo(() => {
    return dropdownAutoList.map(emp => ({
      value: String(emp.emp_id),
      label: emp.emp_no          
    }));
  }, [dropdownAutoList]);


  // const handleEdit = (row) => {
  //   setIsEdit(true);
  //   setEditId(row.project_id);
    
  //   const selectedIds = row.project_owner_id ? row.project_owner_id.split(",").map(id => id.trim()) : []; //row.project_owner_id ? row.staff_assign_id.split(",") : [];
  //   const trimmedSelectedIds = selectedIds.map(str => str.trim());
  //   const selectedValues = clientProjectDropdown?.project_owner_id ? clientProjectDropdown?.project_owner_id.filter(option => trimmedSelectedIds.includes(String(option.value))) : [];
  //   console.log("selectedIds>>>>>>",clientProjectDropdown)
  //   // Client
  //   const clientObj = { value: row.client_id, label: row.client_name };
  //   setClientData(clientObj);
  //   formik.setFieldValue("client", clientObj);

  //   // 🔴 STORE service IDs ONLY
  //   const serviceIds = row.ServiceId ? row.ServiceId.split(",").map(id => id.trim()) : [];
  //   setEditServiceIds(serviceIds);

  //   // Reset service until options load
  //   formik.setFieldValue("service", []);
  //   setServiceData([]);

  //   // Fetch services AFTER client
  //   fetchServiceData(row.client_id);

  //   // AssignTo (same as before)
  //   // const assignIds = row.project_owner_id ? row.project_owner_id.split(",").map(id => id.trim()) : [];
  //   // seteditassignidIds(assignIds);
      

  //   const selectedAssignTo = clientProjectDropdown?.assignTo?.filter(opt =>
  //     assignIds.includes(String(opt.value))
  //   ) || [];

  //   // formik.setFieldValue("assignTo", selectedAssignTo);    

  //   formik.setValues({
  //     project_id: row.project_id,
  //     projectCode: row.project_code,
  //     projectName: row.project_name,
  //     description: row.project_description,
  //     hours: row.project_hours,
  //     projectStatus: row.status_name,
  //     assignTo: selectedValues,
  //   }); 
    
  //   formik.setFieldValue("assignTo", selectedValues);
  //   formik.setFieldValue("projectStatus", { value: row.status, label: row.status_name });
  // };


  const handleToggleStatus = (id,isActive) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `You are about to ${isActive ? 'deactivate' : 'activate'} this project.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: false,
        dangerMode: true,
    }).then((result) => {
        if (result.isConfirmed) {
            const formData = new FormData();
            formData.append("project_id", id);
            formData.append("create_by", authDetails?.user_id);
            formData.append("unit_id", authDetails?.unit_id);
            dispatch(changeProjectStatus(formData));
        }       
    });
  };

  const CustomSelect = ({
    closeMenuOnScroll = true,
    menuPortalTarget = document.body,
    menuPosition = "fixed",
    menuShouldScrollIntoView = false,
    ...props
  }) => {
    return (
      <Select
        {...props}
        closeMenuOnScroll={closeMenuOnScroll}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    );
  };

  const fetchServiceData = (id) => {      
    const formData = new FormData();
    formData.append("client_id", id);
    // formData.append("create_by", authDetails?.user_id);
    formData.append("unit_id", authDetails?.unit_id);
    // dispatch(fetchClientProjectService(formData));
    dispatch(getProserviceList(formData));
  };

  const generateProjectCode = (id,client_id='') => { 
    const formData = new FormData();
    formData.append("client_id", client_id ? client_id : clientData?.value);
    // formData.append("service_id", id);
    formData.append("create_by", authDetails?.user_id);
    formData.append("unit_id", authDetails?.unit_id);
    dispatch(fetchClientProjectDropdown(formData));
  };  

  const resetFormData = () => {
    formik.resetForm(); 
    setIsEdit(false);
    setEditId(null);
    // setIsEdit(false); 
    // setAssignToIds([]);
    // setEditId(null);
    // setClientData(null);
    // setAssignToData(null);
    // setServiceData(null);
    // formik.values.projectCode='';   
    // dispatch(fetchClientProjectDropdownClear());
    // formik.setFieldValue("projectCode", '');
    // formik.resetForm();
  };

  // const columns = [    
  //   { Header: "S.No", Cell: ({ row }) => project.length - row.index, className: "serial-no text-center", applyHeaderClass: true, },
  //   { Header: "Client", accessor: "client_name" },
  //   { Header: "Service", accessor: "service_name" },
  //   { Header: "Project Code", accessor: "project_code" },
  //   { Header: "Project Name", accessor: "project_name" },
  //   { Header: "Description", accessor: "project_description" },
  //   { Header: "Hours", accessor: "project_hours" },
  //   { Header: "Assign To", accessor: "staff_assigns" },
  //   { Header: "Created By", accessor: "create_by" },
  //   { Header: "Created On", accessor: "create_date" },
  //   {
  //     Header: "Actions",
  //     headerClassName: 'text-center',
  //     className: 'text-center',
  //     Cell: (cellProps) => {
  //       const { b_active, project_id} = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="text-center">
  //             <Link to="#" className="me-2" style={{ color: isActive ? "green" : "red" }} onClick={() => handleToggleStatus(project_id,isActive)}>
  //               <i className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`} id={`status-tooltip-${cellProps.row.id}`}/>
  //               <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //                   {isActive ? "Mark Inactive" : "Mark Active"}
  //               </UncontrolledTooltip>
  //             </Link>
  //             <Link to="#" className="text-success ml-3" onClick={() => handleEdit(cellProps.row.original)}>
  //               <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //               <UncontrolledTooltip placement="top" target="edittooltip">
  //                   Edit
  //               </UncontrolledTooltip>
  //             </Link>
  //         </div>
  //       );
  //     },
  //   },
  // ];


  const handleRowChange = (index, field, value) => {
    formik.setFieldValue(`rows[${index}].${field}`, value, false);
  };

  const handleDeleteRow = React.useCallback((deleteIndex) => {
    formik.setFieldValue(
      "rows",
      formik.values.rows.filter((_, i) => i !== deleteIndex),
      false // 🔥 prevent extra validation render
    );
  }, [formik.values.rows]);


  const handleProjectNameChange = (index, value) => {
    const updatedRows = [...formik.values.rows];
    updatedRows[index] = {
      ...updatedRows[index],
      project_name: value,
    };

    formik.setFieldValue("rows", updatedRows);
  };


 const service_columns = React.useMemo(() => {
    const columns = [];

    // ✅ Action column → ONLY in create mode
    if (!editId) {
      columns.push({
        id: "action",
        Header: "Action",
        className: "serial-no text-center",
        Cell: ({ row }) => {
          const index = row.index;

          return (
            <span
              className="text-danger cursor-pointer"
              onClick={() => handleDeleteRow(index)}
            >
              <i className="mdi mdi-delete font-size-18" />
            </span>
          );
        },
      });
    }

    // S.No
    columns.push({
      Header: "S.No",
      Cell: ({ row }) => formik.values.rows.length - row.index,
      className: "serial-no text-center",
      applyHeaderClass: true,
    });

    // Service
    columns.push({
      Header: "Service",
      id: "service",
      className: "desc-col",
      applyHeaderClass: true,
      Cell: ({ row }) => row.original.service,
    });

    // Project Code
    // columns.push({
    //   Header: "Project Code",
    //   id: "project_code",
    //   className: "desc-col",
    //   applyHeaderClass: true,
    //   Cell: ({ row }) => {
    //     const seq = row.index + 1;

    //     // Edit → show DB value only
    //     if (editId) {
    //       return row.original.project_code;
    //     }

    //     // Create → concat index
    //     return `${row.original.project_code} ${seq}`;
    //   },
    // });

    columns.push({
      Header: "Project Code",
      id: "project_code",
      className: "desc-col",
      applyHeaderClass: true,
      Cell: ({ row }) => {
        // ✅ Use orgProjectCount as base, then add row index
       const seq =
      (orgProjectCount ? Number(orgProjectCount) : 0) + row.index + 1;

        // Edit → show DB value only
        if (editId) {
          return row.original.project_code;
        }

        // Create → concat index
        return `${row.original.project_code} ${seq}`;
      },
    });


    // Project Name
    columns.push({
      Header: (
        <>
          Name <span className="text-danger">*</span>
        </>
      ),
      id: "project_name",
      className: "desc-select-col",
      applyHeaderClass: true,
      Cell: ({ row }) => {
        const index = row.index;

        const [localValue, setLocalValue] = React.useState(
          formik.values.rows[index]?.project_name || ""
        );

        React.useEffect(() => {
          setLocalValue(formik.values.rows[index]?.project_name || "");
        }, [formik.values.rows[index]?.project_name]);

        const error =
          formik.touched.rows?.[index]?.project_name &&
          formik.errors.rows?.[index]?.project_name;

        const handleBlur = async () => {
          if (localValue !== formik.values.rows[index]?.project_name) {
            await formik.setFieldValue(
              `rows[${index}].project_name`,
              localValue,
              true // 🔥 validate immediately
            );
          }

          formik.setFieldTouched(`rows[${index}].project_name`, true, true);
        };

        return (
          <>
            <Input
              type="text"
              value={localValue}
              onChange={(e) => setLocalValue(e.target.value)}
              onBlur={handleBlur}   // ✅ update only on focus out
              className={`form-control ${error ? "is-invalid" : ""}`}
              style={{ border: "1px solid #ced4da" }}
            />
            {error && <div className="text-danger small">{error}</div>}
          </>
        );
      },
    });

    // Project Status
      columns.push({
        Header: (
          <>
            Status <span className="text-danger">*</span>
          </>
        ),
        id: "project_status",
        className: "desc-select-col",
        applyHeaderClass: true,
        Cell: ({ row }) => {
          const index = row.index;
          const error =
            formik.touched.rows?.[index]?.project_status &&
            formik.errors.rows?.[index]?.project_status;

          const selectedOption =
            PROJECT_STATUS_OPTIONS.find(
              opt => opt.value === formik.values.rows[index]?.project_status
            ) || null;

          return (
            <>
              <CustomSelect
                options={PROJECT_STATUS_OPTIONS}
                value={selectedOption}
                onChange={async (val) => {
                  await formik.setFieldValue(
                    `rows[${index}].project_status`,
                    val?.value || "",
                    true // 🔥 trigger validation
                  );
                  formik.setFieldTouched(`rows[${index}].project_status`, true, true);
                }}
                className={error ? "is-invalid" : ""}
              />
              {error && <div className="text-danger small">{error}</div>}
            </>
          );
        },
      });

    // Assigned To
    columns.push({
      Header: (
        <>
          Assigned To <span className="text-danger">*</span>
        </>
      ),
      id: "assigned_to",
      className: "desc-select-col",
      applyHeaderClass: true,
      Cell: ({ row }) => {
        const index = row.index;
        const error =
          formik.touched.rows?.[index]?.assigned_to &&
          formik.errors.rows?.[index]?.assigned_to;

        const selectedOption =
          userOptions.find(
            opt => opt.value === formik.values.rows[index]?.assigned_to
          ) || null;

        return (
          <>
            <CustomSelect
              options={userOptions}
              value={selectedOption}
              onChange={async (val) => {
                await formik.setFieldValue(
                  `rows[${index}].assigned_to`,
                  val?.value || "",
                  true
                );
                formik.setFieldTouched(`rows[${index}].assigned_to`, true, true);
              }}
              className={error ? "is-invalid" : ""}
            />
            {error && <div className="text-danger small">{error}</div>}
          </>
        );
      },
    });

    // Total Hours
    columns.push({
      Header: (
        <>
          Total Hours <span className="text-danger">*</span>
        </>
      ),
      id: "total_hours",
      className: "action-col",
      applyHeaderClass: true,
      Cell: ({ row }) => {
        const index = row.index;
        const [localValue, setLocalValue] = React.useState(
          formik.values.rows[index]?.total_hours || ""
        );

        React.useEffect(() => {
          setLocalValue(formik.values.rows[index]?.total_hours || "");
        }, [formik.values.rows[index]?.total_hours]);

        const error =
          formik.touched.rows?.[index]?.total_hours &&
          formik.errors.rows?.[index]?.total_hours;

        return (
          <>
            <Input
              type="text"
              className={`form-control ${error ? "is-invalid" : ""}`}
              style={{ width: "95px" }}
              placeholder="HHHH:mm"
              value={localValue}
              // onChange={(e) =>
              //   setLocalValue(formatTimeWithColon(e.target.value))
              // }
              // // onBlur={() => {
              // //   const normalized = normalizeHours(localValue);
              // //   setLocalValue(normalized);
              // //   handleRowChange(index, "total_hours", normalized);
              // //   formik.setFieldTouched(`rows[${index}].total_hours`, true);
              // // }}
              // onBlur={async () => {
              //     const normalized = normalizeHours(localValue);
              //     setLocalValue(normalized);

              //     await formik.setFieldValue(
              //       `rows[${index}].total_hours`,
              //       normalized,
              //       true
              //     );

              //     formik.setFieldTouched(`rows[${index}].total_hours`, true, true);
              //   }}
              onChange={(e) =>
                setLocalValue(formatWhileTyping(e.target.value))
              }
              onBlur={async () => {
                const formatted = formatOnBlur(localValue);
                setLocalValue(formatted);
 
                await formik.setFieldValue(
                  `rows[${index}].total_hours`,
                  formatted,
                  true
                );
 
                formik.setFieldTouched(
                  `rows[${index}].total_hours`,
                  true,
                  true
                );
              }}
            />
            {error && <div className="text-danger small">{error}</div>}
          </>
        );
      },
    });

    return columns;
  }, [editId, formik.values.rows, formik.errors, formik.touched]);


  const columns = [
  {
    Header: "Actions",
    headerClassName: "text-center",
    className: "text-center",
    Cell: (cellProps) => {
      const { b_active, project_id } = cellProps.row.original;
      const isActive = Number(b_active) === 1;

      return (
        <div className="text-center">

          {/* STATUS TOGGLE */}
          {canDelete && (
            <>
              <span
                id={`status-${project_id}`}
                className="me-2"
                style={{ color: isActive ? "green" : "red", cursor: "pointer" }}
                onClick={() => handleToggleStatus(project_id, isActive)}
              >
                <i
                  className={`mdi ${
                    isActive ? "mdi-check-circle" : "mdi-close-circle"
                  } font-size-18`}
                />
              </span>

              <UncontrolledTooltip
                placement="top"
                target={`status-${project_id}`}
                delay={{ show: 300, hide: 100 }}
              >
                {isActive ? "Mark Inactive" : "Mark Active"}
              </UncontrolledTooltip>
            </>
          )}

          {/* EDIT */}
          {canEdit && (
            <>
              <span
                id={`edit-${project_id}`}
                className="text-success ms-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleEdit(cellProps.row.original)}
              >
                <i className="bx bxs-edit font-size-18" />
              </span>

              <UncontrolledTooltip
                placement="top"
                target={`edit-${project_id}`}
                delay={{ show: 300, hide: 100 }}
              >
                Edit
              </UncontrolledTooltip>
            </>
          )}

        </div>
      );
    },
  },

  { Header: "S.No", Cell: ({ row }) => project_list.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
  { Header: "Client", accessor: "client_name" , className: "desc-col", applyHeaderClass: true},
  { Header: "Service", accessor: "service_name", className: "desc-col", applyHeaderClass: true  },
  { Header: "Project Code", accessor: "project_code", className: "desc-col", applyHeaderClass: true },
  { Header: "Project Name", accessor: "project_name", className: "desc-col", applyHeaderClass: true },
  { Header: "Project Name Details", accessor: "project_name_details", className: "desc-col", applyHeaderClass: true },
  { Header: "Service Type", accessor: "service_type", className: "desc-col", applyHeaderClass: true },  
  // { Header: "Project Owner", accessor: "project_owner", className: "desc-col", applyHeaderClass: true },
  { Header: "Account Owner", accessor: "account_manager" , className: "desc-col", applyHeaderClass: true},
  { Header: "Hours", accessor: "project_hours" },
  { Header: "Assign To", accessor: "service_assigned_to", className: "desc-col", applyHeaderClass: true  },
  { Header: "Created By", accessor: "create_by", className: "desc-col", applyHeaderClass: true },
  { Header: "Created On", accessor: "create_date" },
  // { Header: "Project Status", accessor: "status_name" },
  {
      Header: "Project Status",
      accessor: "status_name",
      Cell: ({ value }) => {
        let icon;
        let color;
        switch (value) {
          case "Completed":
            icon = <FaCheckCircle />;
            color = "green";
            break;
          case "In progress":
            icon = <FaSpinner />;
            color = "Blue";
            break;
          case "Dropped":
            icon = <FaTimesCircle />;
            color = "red";
            break;
          case "Yet to start":
            icon = <FaHourglass />;
            color = "orange";
            break;
          case "On hold":
            icon = <FaPauseCircle />;
            color = "Amber";
            break;
          default:
            icon = "";
            color = "gray";
        }
 
        return (
          <div style={{ display: "flex", alignItems: "center", color, fontWeight: "bold" }}>
            {icon}
            <span style={{ marginLeft: 8 }}>{value}</span>
          </div>
        );
      },
      className: "desc-col",
      applyHeaderClass: true,
    },
  { Header: "Description", accessor: "project_description", className: "desc-col", applyHeaderClass: true },
  { Header: "project value", accessor: "project_value", className: "desc-col", applyHeaderClass: true },
];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Project" />
        <Card>
          <CardBody>
            <Form >
              <Row className="mb-2">
                <Col md={3}>
                  <FormGroup>
                    <Label>Client <span className="text-danger">*</span></Label>
                    {/* <CustomSelect
                        id="client"
                        name="client"
                        isMulti={false}
                        options={clientActiveList}
                        value={clientData}
                        onChange={(selectedOption) => {formik.setFieldValue("client", selectedOption);setClientData(selectedOption);fetchServiceData(selectedOption?.value);}}
                        onBlur={() => formik.setFieldTouched("client", true)}
                    />  */}
                    <CustomSelect
                      id="client"
                      name="client"
                      isMulti={false}
                      options={Array.isArray(clientActiveList) ? clientActiveList : []}
                       closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={
                        clientActiveList?.find(
                          opt => opt.value === formik.values.client
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        // ✅ set client (store only value)
                        formik.setFieldValue("client", selectedOption?.value || "");

                        // 🔴 RESET service selection
                        formik.setFieldValue("service", []);

                        // 🔵 fetch services for selected client
                        if (selectedOption?.value) {
                          fetchServiceData(selectedOption.value);
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("client", true)}
                      isDisabled={!!editId}
                    />
                    {formik.touched.client && formik.errors.client && (
                      <div className="text-danger">{formik.errors.client}</div>
                    )}
                  </FormGroup>
                </Col>
                {/* <Col md={4}>
                  <FormGroup>
                    <Label>Service <span className="text-danger">*</span></Label>
                    <CustomSelect
                        id="service"
                        name="service"
                        isMulti={false}
                        options={clientProjectService}
                        value={serviceData}
                        onChange={(selectedOption) => {formik.setFieldValue("service", selectedOption);setServiceData(selectedOption);generateProjectCode(selectedOption?.value,'');}}
                        onBlur={() => formik.setFieldTouched("service", true)}
                    />                     
                    {formik.touched.service && formik.errors.service && (
                      <div className="text-danger">{formik.errors.service}</div>
                    )}
                  </FormGroup>
                </Col> */}
                {/* <Col md={4}>
                  <FormGroup>
                    <Label>
                      Service <span className="text-danger">*</span>
                    </Label>

                    <CustomSelect
                      id="service"
                      name="service"
                      isMulti={true}                     // ✅ enable multi select
                      options={Array.isArray(clientProjectService) ? clientProjectService : []}
                      value={Array.isArray(formik.values.service) ? formik.values.service : []}
                      onChange={(selectedOptions) => {
                        formik.setFieldValue("service", selectedOptions);
                        setServiceData(selectedOptions);

                        // if you need values only
                        const serviceIds = selectedOptions?.map(opt => opt.value);
                        generateProjectCode(serviceIds, '');
                      }}
                      onBlur={() => formik.setFieldTouched("service", true)}
                    />

                    {formik.touched.service && formik.errors.service && (
                      <div className="text-danger">{formik.errors.service}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Project Code <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="projectCode"
                      value={formik.values.projectCode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.errors.projectCode && formik.touched.projectCode ? "is-invalid" : ""}
                    />
                    {formik.errors.projectCode && formik.touched.projectCode && (
                      <div className="text-danger">{formik.errors.projectCode}</div>
                    )}
                  </FormGroup>
                </Col> */}
                <Col md={3}>
                  <FormGroup>
                    <Label>Project Name <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="projectName"
                      maxLength={50}
                      value={formik.values.projectName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.errors.projectName && formik.touched.projectName ? "is-invalid" : ""}
                      disabled={!!editId}
                    />
                    {formik.errors.projectName && formik.touched.projectName && (
                      <div className="text-danger">{formik.errors.projectName}</div>
                    )}
                  </FormGroup>
                </Col>                
                <Col md={3}>
                  <FormGroup>
                    <Label>Project Hours <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="hours"
                      placeholder="HHHH:MM"
                      value={formik.values.hours}
                      // onChange={formik.handleChange}
                      // onBlur={formik.handleBlur}
                      onChange={(e) =>
                        formik.setFieldValue("hours", formatWhileTyping(e.target.value))
                      }
                      onBlur={() => {
                        const formatted = formatOnBlur(formik.values.hours);
                        formik.setFieldValue("hours", formatted);
                        // formik.setFieldTouched("hours", true);
                      }}
                      className={formik.errors.hours && formik.touched.hours ? "is-invalid" : ""}
                    />
                    {formik.errors.hours && formik.touched.hours && (
                      <div className="text-danger">{formik.errors.hours}</div>
                    )}                                    
                  </FormGroup>
                </Col>                
                {/* <Col md={3}>
                  <FormGroup>
                    <Label>
                      Project Owner <span className="text-danger">*</span>
                    </Label>

                    <CustomSelect
                      id="assignTo"
                      name="assignTo"
                      isMulti={false}   // ✅ single select
                      options={userOptions}
                      value={
                        userOptions.find(
                          opt => opt.value === formik.values.assignTo
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          "assignTo",
                          selectedOption?.value || ""
                        )
                      }
                      onBlur={() => formik.setFieldTouched("assignTo", true)}
                    />

                    {formik.touched.assignTo && formik.errors.assignTo && (
                      <div className="text-danger">
                        {formik.errors.assignTo}
                      </div>
                    )}
                  </FormGroup>
                </Col> */}
                <Col md={3}>
                  <FormGroup>
                    <Label>
                      Account Owner <span className="text-danger">*</span>
                    </Label>

                    <CustomSelect
                      id="accountOwner"
                      name="accountOwner"
                      isMulti={false}
                      options={userOptions}
                       closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={
                        userOptions.find(
                          opt => opt.value === formik.values.accountOwner
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          "accountOwner",
                          selectedOption?.value || ""
                        )
                      }
                      onBlur={() =>
                        formik.setFieldTouched("accountOwner", true)
                      }
                    />

                    {formik.touched.accountOwner && formik.errors.accountOwner && (
                      <div className="text-danger">
                        {formik.errors.accountOwner}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                {/* <Col md={3}>
                  <FormGroup>
                    <Label>
                      Project Status <span className="text-danger">*</span>
                    </Label>

                    <CustomSelect
                      id="projectStatus"
                      name="projectStatus"
                      isMulti={false}
                      options={PROJECT_STATUS_OPTIONS}
                      value={formik.values.projectStatus}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("projectStatus", selectedOption);
                      }}
                      onBlur={() => formik.setFieldTouched("projectStatus", true)}
                    />

                    {formik.touched.projectStatus && formik.errors.projectStatus && (
                      <div className="text-danger">{formik.errors.projectStatus}</div>
                    )}
                  </FormGroup>
                </Col> */}
                <Col md={3}>
                  <FormGroup>
                    <Label>Project Description</Label>
                    {/* <Input
                      type="textarea"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      style={{ maxHeight: "33.1px", minHeight: "33.1px" }}
                    /> */}
                    <Input
                        type="textarea"
                        name="description"
                        maxLength={200}
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        style={{
                          minHeight: "33.1px",
                          maxHeight: "33.1px",
                          resize: "none"
                        }}
                        className={
                          formik.touched.description && formik.errors.description
                            ? "is-invalid"
                            : ""
                        }
                      />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Project Value</Label>
                    <Input
                      type="text"
                      name="projectvalue"
                      maxLength={200}
                      value={formik.values.projectvalue}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={
                        formik.touched.projectvalue && formik.errors.projectvalue
                          ? "is-invalid"
                          : ""
                      }
                    />
                  </FormGroup>
                </Col>
                {/* <Col md="8" className="text-end mt-4">
                  <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" />{editId ? "Update" : "Save"} </Button>
                  <Button type="button" className="btn button-cancel" onClick={() => { resetFormData(); }}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>                               */}
                {formik.values.rows && formik.values.rows.length > 0 && (
                  <Row>
                    <div className="table-scroll-x">
                      <TableContainer
                        columns={service_columns}
                        data={formik.values.rows}
                        isGlobalFilter={false}
                        customPageSize={10}
                        tableSorter={false}
                      />
                    </div>                    
                  </Row>
                )}                
                <Col className="d-flex mob-center align-items-center justify-content-end mt-2">                
                  {canCreate && (
                    <Button  color="primary" className="btn button-save me-2" onClick={formik.handleSubmit}>
                      <i className="fas fa-save me-1" /> {editId ? "Update" : "Save"}
                    </Button>
                  )}
                  <Button type="button" className="btn button-cancel me-2" onClick={() => { resetFormData(); }}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={project_list}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimeSheetProject;
